// Kamadoteca sections: EVO picker, classic lineup, accessory filters and the
// "no product linked yet" notice for kt-add forms. Re-inits on theme-editor reloads.
(() => {
  const COLOUR_ES = { black: 'Negro', red: 'Rojo' };

  function toast(msg) {
    let host = document.querySelector('.kt-toast-host');
    if (!host) {
      host = document.createElement('div');
      host.className = 'kt kt-toast-host';
      host.innerHTML = '<div class="toast" role="status" aria-live="polite"></div>';
      document.body.appendChild(host);
    }
    const t = host.firstElementChild;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toast.timer);
    toast.timer = setTimeout(() => t.classList.remove('show'), 2800);
  }

  function setAdd(form, variant, name) {
    if (!form) return;
    form.querySelector('input[name=id]').value = variant || '';
    if (name) form.dataset.name = name;
  }

  function hexToGlow(hex) {
    const m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
    if (!m) return 'rgba(255,122,69,.26)';
    const n = parseInt(m[1], 16);
    return `rgba(${n >> 16},${(n >> 8) & 255},${n & 255},.26)`;
  }

  function initEvo(root) {
    const $ = (r) => root.querySelector(`[data-ref=${r}]`);
    const sws = [...root.querySelectorAll('.cols .sw')];
    if (!sws.length) return;
    const img = $('img'), stage = $('stage'), lid = $('lid');
    // Drawn width per model, so the three sizes read at roughly true scale.
    const WIDTH = { minimo: '54%', media: '80%', grande: '90%' };
    const state = { sw: sws.find((s) => s.getAttribute('aria-pressed') === 'true') || sws[0], open: false };
    sws.forEach((s) => [s.dataset.img, s.dataset.open].forEach((u) => { if (u) new Image().src = u; }));

    function render() {
      const s = state.sw, model = s.dataset.model;
      sws.forEach((x) => { x.hidden = x.dataset.model !== model; x.setAttribute('aria-pressed', x === s); });
      root.querySelectorAll('[data-ref=models] button').forEach((b) => b.setAttribute('aria-pressed', b.dataset.m === model));
      const src = state.open && s.dataset.open ? s.dataset.open : s.dataset.img;
      if (img && img.getAttribute('src') !== src) {
        img.classList.add('swap');
        setTimeout(() => { img.src = src; img.classList.remove('swap'); }, 160);
      }
      if (img) img.alt = s.dataset.name + (state.open ? ', con la tapa abierta' : '');
      stage.style.setProperty('--w', WIDTH[model] || '84%');
      stage.style.setProperty('--glow', hexToGlow(s.dataset.glow));
      $('colname').textContent = s.dataset.name;
      $('price').innerHTML = `${s.dataset.price}<small>IVA incl.</small>`;
      $('note').textContent = root.dataset['note' + model.charAt(0).toUpperCase() + model.slice(1)] || '';
      lid.setAttribute('aria-pressed', state.open);
      lid.querySelector('span').textContent = state.open ? 'Cerrar la tapa' : 'Abrir la tapa';
      setAdd(root.querySelector('.evo-buy .kt-add'), s.dataset.variant, s.dataset.name);
    }
    root.querySelector('[data-ref=models]')?.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      state.sw = sws.find((x) => x.dataset.model === b.dataset.m) || state.sw; render();
    });
    root.querySelector('[data-ref=cols]').addEventListener('click', (e) => {
      const b = e.target.closest('.sw'); if (!b) return; state.sw = b; render();
    });
    lid.addEventListener('click', () => { state.open = !state.open; render(); });
    render();
  }

  function initLineup(root) {
    const lane = root.querySelector('.lane'), detail = root.querySelector('.detail');
    const $ = (r) => detail.querySelector(`[data-ref=${r}]`);
    const sws = [...detail.querySelectorAll('.sw')];
    let cur = lane.querySelector('.gr.on') || lane.querySelector('.gr');
    if (!cur) return;

    function pick(btn, col) {
      cur = btn;
      if (col) btn.dataset.col = col;
      const c = btn.dataset.col;
      lane.querySelectorAll('.gr').forEach((b) => { b.classList.toggle('on', b === btn); b.setAttribute('aria-pressed', b === btn); });
      const src = btn.dataset[c === 'red' ? 'imgRed' : 'imgBlack'];
      if (src) btn.querySelector('img').src = src;
      $('name').textContent = btn.dataset.name;
      $('desc').textContent = btn.dataset.desc;
      $('cm').textContent = btn.dataset.cm + ' cm';
      $('ppl').textContent = btn.dataset.ppl;
      $('price').innerHTML = `${btn.dataset.price}<small>IVA incl.</small>`;
      $('colname').textContent = COLOUR_ES[c];
      sws.forEach((s) => {
        s.hidden = !btn.dataset[s.dataset.c === 'red' ? 'imgRed' : 'imgBlack'];
        s.setAttribute('aria-pressed', s.dataset.c === c);
      });
      setAdd(detail.querySelector('.kt-add'), btn.dataset[c === 'red' ? 'vRed' : 'vBlack'], `Kamado ${btn.dataset.name} ${COLOUR_ES[c].toLowerCase()}`);
    }
    lane.addEventListener('click', (e) => { const b = e.target.closest('.gr'); if (b) pick(b); });
    sws.forEach((s) => s.addEventListener('click', () => pick(cur, s.dataset.c)));
    pick(cur);

    // Size questions: diners inside a kamado's range score 3 (else minus the
    // distance), a matching place adds 2. Ties go to the smaller size.
    const finder = root.querySelector('[data-ref=finder]');
    if (!finder) return;
    const grills = [...lane.querySelectorAll('.gr')];
    const answer = (q) => finder.querySelector(`[data-q=${q}] [aria-pressed=true]`)?.dataset.v;
    const score = (g, ppl, place) => {
      const min = +g.dataset.min, max = +g.dataset.max;
      const fit = !ppl ? 0 : ppl < min ? -(min - ppl) : ppl > max ? -(ppl - max) : 3;
      return fit + (place && g.dataset.places.split(' ').includes(place) ? 2 : 0);
    };
    finder.addEventListener('click', (e) => {
      const b = e.target.closest('.chip'); if (!b) return;
      b.parentElement.querySelectorAll('.chip').forEach((x) => x.setAttribute('aria-pressed', x === b));
      const ppl = +answer('ppl') || 0, place = answer('place');
      let best = grills[0];
      grills.forEach((g) => { if (score(g, ppl, place) > score(best, ppl, place)) best = g; });
      grills.forEach((g) => { g.querySelector('.rec').hidden = g !== best; });
      pick(best);
      best.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
  }

  function initAcc(root) {
    const chips = root.querySelector('.chips');
    chips?.addEventListener('click', (e) => {
      const c = e.target.closest('.chip'); if (!c) return;
      chips.querySelectorAll('.chip').forEach((x) => x.setAttribute('aria-pressed', x === c));
      root.querySelectorAll('.acc').forEach((a) => { a.hidden = c.dataset.f !== 'all' && a.dataset.f !== c.dataset.f; });
    });
  }

  // Catalogue: category / brand / search filters and sorting over the rendered cards.
  // The chosen category is mirrored in the URL hash (#ahumado) so it can be linked.
  function initCatalog(root) {
    const $ = (r) => root.querySelector(`[data-ref=${r}]`);
    const grid = $('grid'), cards = [...grid.querySelectorAll('.pc')], navBtns = [...root.querySelectorAll('.cn')];
    // type: one product-type handle, or several joined by ',' (e.g. from the header's Accesorios link).
    const state = { type: '', vendor: '', q: '', sort: '' };
    const fromHash = decodeURIComponent(location.hash.slice(1));
    const known = (t) => navBtns.some((b) => b.dataset.type === t);
    if (fromHash && fromHash.split(',').every(known)) state.type = fromHash;

    function apply() {
      const q = state.q.trim().toLowerCase();
      const types = state.type ? state.type.split(',') : [];
      let shown = 0;
      for (const c of cards) {
        const ok = (!types.length || types.includes(c.dataset.type)) && (!state.vendor || c.dataset.vendor === state.vendor) && (!q || c.dataset.name.includes(q));
        c.hidden = !ok;
        if (ok) shown++;
      }
      const key = { 'price-asc': (a, b) => a.dataset.price - b.dataset.price, 'price-desc': (a, b) => b.dataset.price - a.dataset.price,
        name: (a, b) => a.dataset.name.localeCompare(b.dataset.name, 'es') }[state.sort] || ((a, b) => a.dataset.i - b.dataset.i);
      [...cards].sort(key).forEach((c) => grid.appendChild(c));
      navBtns.forEach((b) => b.setAttribute('aria-pressed', b.dataset.type === state.type));
      $('count').textContent = shown;
      $('empty').hidden = shown > 0;
      history.replaceState(null, '', state.type ? `#${state.type}` : location.pathname + location.search);
    }
    root.querySelector('.cat-nav').addEventListener('click', (e) => {
      const b = e.target.closest('.cn'); if (!b) return;
      state.type = b.dataset.type; apply();
      b.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
    $('vendor').addEventListener('change', (e) => { state.vendor = e.target.value; apply(); });
    $('sort').addEventListener('change', (e) => { state.sort = e.target.value; apply(); });
    $('q').addEventListener('input', (e) => { state.q = e.target.value; apply(); });
    // Header links into the catalogue change only the hash when already on this page.
    window.addEventListener('hashchange', () => {
      const h = decodeURIComponent(location.hash.slice(1));
      if (h.split(',').every(known)) { state.type = h; apply(); }
    });
    $('reset').addEventListener('click', () => {
      Object.assign(state, { type: '', vendor: '', q: '' });
      $('vendor').value = ''; $('q').value = ''; apply();
    });
    apply();
  }

  function initFinder(root) {
    const cards = [...root.querySelectorAll('.fd-card')];
    const answer = (q) => root.querySelector(`[data-q=${q}] [aria-pressed=true]`)?.dataset.v;
    function score(c, ppl, place) {
      const min = +c.dataset.min, max = +c.dataset.max;
      const fit = ppl < min ? -(min - ppl) : ppl > max ? -(ppl - max) : 3;
      return fit + (c.dataset.places.split(' ').includes(place) ? 2 : 0);
    }
    function render() {
      const ppl = +answer('ppl'), place = answer('place');
      let best = cards[0];
      cards.forEach((c) => { if (score(c, ppl, place) > score(best, ppl, place)) best = c; });
      cards.forEach((c) => { c.hidden = c !== best; });
      // Offer the next size up for when guests come, unless this is the largest.
      const up = cards[cards.indexOf(best) + 1], alt = best.querySelector('[data-ref=alt]');
      alt.textContent = '';
      if (up && place !== 'go') {
        const link = up.querySelector('.fd-ctas a');
        alt.append('¿Sueles tener invitados? Mira también el ');
        const a = document.createElement('a'); a.href = link.href; a.textContent = up.dataset.name;
        alt.append(a, '.');
      }
    }
    root.querySelectorAll('[data-q]').forEach((group) => group.addEventListener('click', (e) => {
      const b = e.target.closest('.chip'); if (!b) return;
      group.querySelectorAll('.chip').forEach((x) => x.setAttribute('aria-pressed', x === b));
      render();
    }));
    render();
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-kt-finder]').forEach(initFinder);
    scope.querySelectorAll('[data-kt-catalog]').forEach(initCatalog);
    scope.querySelectorAll('[data-kt-evo]').forEach(initEvo);
    scope.querySelectorAll('[data-kt-lineup]').forEach(initLineup);
    scope.querySelectorAll('[data-kt-acc]').forEach(initAcc);
  }

  // Links like <a href="#evo" data-kt-pick="grande"> also switch the EVO picker to that model.
  document.addEventListener('click', (e) => {
    const a = e.target.closest?.('[data-kt-pick]');
    if (!a) return;
    document.querySelector(`[data-kt-evo] [data-ref=models] [data-m="${a.dataset.ktPick}"]`)?.click();
  });

  // Product page stock label (blocks/kt-availability): Horizon only morphs the variant
  // picker, so swap the label from the variant:update event's HTML.
  document.addEventListener('variant:update', (e) => {
    const html = e.detail?.data?.html;
    if (!html) return;
    for (const el of document.querySelectorAll('[data-kt-avail]')) {
      const next = html.querySelector(`[data-kt-avail="${el.dataset.ktAvail}"]`);
      if (next) { el.className = next.className; el.innerHTML = next.innerHTML; }
    }
  });

  // Pack colour pills: show the pack picture in the chosen colour.
  document.addEventListener('change', (e) => {
    const r = e.target.closest?.('.bcolors input[data-img]');
    const img = r?.closest('.bundle')?.querySelector('.bpics .g');
    if (img) img.src = r.dataset.img;
  });

  // Forms without a linked product: explain instead of posting an empty cart line.
  document.addEventListener('submit', (e) => {
    const f = e.target.closest?.('.kt-add');
    if (!f || f.querySelector('input[name=id]').value) return;
    e.preventDefault();
    toast(`${f.dataset.name || 'Este producto'}: llámanos o escríbenos para reservarlo.`);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
